import { logger } from "capsule"
import firebase from "firebase/compat/app"

import preprodConfig from "./preprod/google-services.json"
import prodConfig from "./prod/google-services.json"

const googleService = process.env.REACT_APP_ENV === "dev" ? preprodConfig : prodConfig

logger("after import")

const app = firebase.initializeApp(googleService)

logger("after init", app)

const firebaseInit = "Init (web)"

export default firebaseInit
